/**
 * Argument is only needed for testing since LH_ENV_NAME forms a stale closure
 * over the env object, at build-time.
 *
 * For vi.stubEnv to work correctly, it needs to read the env object after
 * the env has been stubbed, otherwise it returns the initial env values.
 */
export const isProductionEnv = (
  envName = import.meta.env.LH_ENV_NAME as string,
) => String(envName).startsWith("prod");

export const isLocalEnv = (envName = import.meta.env.LH_ENV_NAME as string) =>
  String(envName) === "localhost";

export const isDevEnvs = (envName = import.meta.env.LH_ENV_NAME as string) =>
  isLocalEnv(envName) || String(envName).startsWith("dev");
